import { render } from "./Toolbox.vue?vue&type=template&id=63d31197&scoped=true"
import script from "./Toolbox.vue?vue&type=script&lang=js"
export * from "./Toolbox.vue?vue&type=script&lang=js"

import "./Toolbox.vue?vue&type=style&index=0&id=63d31197&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-63d31197"

export default script